import { getPageUrl } from "#scripts/general_functions.js";
import { adminPage } from "#templates/pages/adminpage.js";
import { navPage } from "#scripts/nav.js";
import { skjemaPage } from "#scripts/skjema.js";
import article from "#templates/pages/article";
import frontpage from "#templates/pages/frontpage";
import { event, eventCustom } from "#templates/pages/event.js";
import { calendarpage, calendarpageCustom } from "#templates/pages/eventlist";
import list from "#templates/pages/list";
import { convertJSON } from "#scripts/convertjson.js";
import { sitemappage } from "#templates/pages/sitemap/sitemap.js";
import { minside } from "#templates/pages/minside";
import fullsearchHive from "#templates/pages/search_haive";
import fullsearchTellusR from "#templates/pages/search_tellusr";


export function getTemplateContent (template, config, navdata) {
  const contentId = getPageUrl().contentid;
  const provider = config?.search?.provider ?? "";
  const localId = config?.calendar?.localid;

  const handlers = {
    "aim-admin": () => adminPage(config),
    "nav": () => navPage(),
    "skjema": () => skjemaPage(config),
    "article": () => article(config),
    "artikkel": () => article(config),
    "blokk": () => article(config),
    "fokus": () => article(config),
    "enhet": () => article(config),
    "unit": () => article(config),
    "sok": () => handleSearchTemplate(provider, contentId),
    "search": () => handleSearchTemplate(provider, contentId),
    "frontpage": () => {
      frontpage();
      return '<div class="container p-md-0"><div id="result__loadfrontpage"></div></div></div>';
    },
    "event": () => event(),
    "event_custom": () => eventCustom(),
    "kalender": () => calendarpage(localId),
    "kalenderliste": () => calendarpage(localId),
    "eventlist": () => calendarpage(localId),
    "eventlist_custom": () => calendarpageCustom(localId),
    "eventgrid": () => calendarpageCustom(localId),
    "list": () => list(config),
    "liste": () => list(config),
    "convertjson": () => convertJSON(),
    "sitemap": () => {
      sitemappage(navdata);
      return null;
    },
    "minside": () => minside(),
    "minkommune": () => minside(),
    "mypage": () => minside(),
    "mymunic": () => minside(),
  };

  return (handlers[template] || (() => article(config)))();
}

function handleSearchTemplate (provider, contentId) {
  switch (provider) {
    case "haive": return fullsearchHive(contentId);
    case "tellusr": return fullsearchTellusR(contentId);
    default: return fullsearchHive(contentId);
  }
}
